export class BeanProfile{
  constructor(
    public perfIdCdPerfil  : number,
    public perfDsPerfil	 : string,
    public perfDhInativo	 : string,
    public perfDhRegistro	 : string
  ){}
}
